import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { NewsletterInfo, NewsletterSectionResponseModel, NewsletterSection, NewsletterEditViewModelV2 } from '../../../models/catalogue-view.model';
import { ApiResponse } from '../../../models/api-response.model';
import { Observable, Subject, Subscription } from '../../../../../node_modules/rxjs';
import { NewsletterEditSectionNameComponent } from '../../../popup-collection/newsletter-edit-section-name/newsletter-edit-section-name.component';
import { NewsletterDeleteSectionComponent } from '../../../popup-collection/newsletter-delete-section/newsletter-delete-section.component';
import { MatDialog } from '@angular/material/dialog';
import { NgProgressService } from '../../../services/ngProgress.service';
import { map, switchMap } from 'rxjs/operators';
import { NewsletterService } from '../../../services/newsletter.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-newsletter-section-v2',
  templateUrl: './newsletter-section-v2.component.html',
  styleUrls: ['./newsletter-section-v2.component.css']
})
export class NewsletterSectionV2Component implements OnInit {

  newsletterSections: NewsletterSection[];
  addingTitle: string = "Adding...";

  titleColor: string;

  catalogueWatchSubscription: Subscription;
  catalogueSubscription: Subscription;
  colorSubscription: Subscription;

  nl_content: string;

  editSectionContent = false;
  editSectionTitleModel: NewsletterSection;
  removeSectionModel: NewsletterSection;
  removeSectionOverlay = false;

  dragDropModel: NewsletterSection;
  targetSectionId: string;
  targetSection: NewsletterSection;
  targetPos: string;
  dragIndex: number;
  targetIndex: number;
  moveIndex: number;
  moveSection: NewsletterSection;
  movePos: string;

  newsletterInfo: NewsletterInfo;
  refreshNewsletterInfo: Subject<NewsletterSectionResponseModel> = new Subject<NewsletterSectionResponseModel>();
  refreshNewsletterInfo$: Observable<NewsletterInfo>;
  newletterToEditId: string;
  @Input() newsletterEditViewModel: NewsletterEditViewModelV2;
  @Input() sendNewIdToSection: string;
  @Output() editSectionEvent = new EventEmitter<boolean>();

  constructor(
    private newsletterService: NewsletterService,
    public ngProgress: NgProgressService,
    private commonService: CommonService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {

    this.ngProgress.start();
    this.refreshNewsletterInfo$ = this.refreshNewsletterInfo.pipe(switchMap((res:NewsletterSectionResponseModel)=> this.newsletterService.getSections(this.sendNewIdToSection).pipe(map(res1 => {
        this.newsletterSections = res1.sectionList.filter(x => x.section_type === 'nl_section');
        this.newsletterInfo = res1;
        if(res != undefined) {
          this.newsletterService.monitorBlockChange(res);
        }
        this.addingTitle = "";
        this.ngProgress.done();
        return res1;
      }))
    ));
    this.refreshNewsletterInfo$.subscribe();
    this.catalogueWatchSubscription = this.newsletterService.currentSectionIdWatch.subscribe((res: string) => {
      this.refreshNewsletterInfo.next();
    },
      (error: any) => {
        console.error(error);
        this.ngProgress.done();
      });

    this.colorSubscription = this.newsletterService.currentColorWatch.subscribe((res: string) => {
      this.titleColor = res;
    });
  }


  editSectionTitle(section: NewsletterSection): void {
    this.nl_content = section.content ? section.content : 'Section Name';
    this.editSectionTitleModel = section;
    const dialogRef = this.dialog.open(NewsletterEditSectionNameComponent, {
      width: '500px',
      panelClass: 'mat-dialog-wrapper',
      data: { nl_content: this.nl_content }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.newletterToEditId = section.section_id;
        this.addingTitle = "Saving section name...";
        this.ngProgress.start();

        this.commonService.set(this.editSectionTitleModel, ['content'], result.nl_content);
        this.editSectionTitleModel.section_pos = '';
        this.editSectionTitleModel.section_type = '';

        this.newsletterService.saveSection(this.editSectionTitleModel)
          .subscribe((res: NewsletterSectionResponseModel) => {
            this.refreshNewsletterInfo.next();
            this.ngProgress.done();
          },
            (error: any) => {
              console.error(error);
              this.ngProgress.done();
            });
      }
    });
  }

  deleteSection(section: NewsletterSection): void {

    const dialogRef = this.dialog.open(NewsletterDeleteSectionComponent, {
      width: '500px',
      panelClass: 'mat-dialog-wrapper',
      data: { type: "section" }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngProgress.start();
        this.newsletterService.deleteSection(this.sendNewIdToSection, section.section_id)
          .subscribe((res: ApiResponse) => {
            this.refreshNewsletterInfo.next();
          },
            (error: any) => {
              console.error(error);
              this.ngProgress.done();
            });
      }
    });
  }

  onDropCDK(event: CdkDragDrop<string[]>): void {
    if (event.previousIndex != event.currentIndex) {
      this.ngProgress.start();

      const nlSecBup = [ ...this.newsletterSections ];
      const dragData = { ...this.newsletterSections[event.previousIndex] };
      const targetData = { ...this.newsletterSections[event.currentIndex] };

      // update front-end list by updating the positions of all the sections, removing the current data, pushing into new location  
      if (event.previousIndex -1 > event.currentIndex) {
        for (var i = event.previousIndex; i >= event.currentIndex; i--) {
          this.newsletterSections[i].section_pos = (this.commonService.toNumber(this.newsletterSections[i].section_pos) + 1).toString();
        }
      }
      else{
        for (var i = event.previousIndex + 1; i <= event.currentIndex; i++) {
          this.newsletterSections[i].section_pos = (this.commonService.toNumber(this.newsletterSections[i].section_pos) - 1).toString();
        }
      }
      this.newsletterSections.splice(event.previousIndex, 1);
      dragData.section_pos = targetData.section_pos;
      this.newsletterSections.splice(event.currentIndex, 0, dragData);

      this.newsletterService.saveSection(dragData).subscribe((res: NewsletterSectionResponseModel) => {
        if (res && res.status) {
          this.commonService.implementToast("Successfully switch section", "Success");
          // last resort is to update from the database again
          //this.refreshNewsletterInfo.next();
          this.ngProgress.done();
        }
      }),
        (error: any) => {
          console.error(error);
          // revert the list to the previous list if fail occurs
          this.newsletterSections = nlSecBup;
          // last resort, refresh list from database just in case
          // this.refreshNewsletterInfo.next();
          this.ngProgress.done();
        }        
    }
  }

  moveUp(section: NewsletterSection): void {
    // gets the index of the section moving up
    this.moveIndex = this.newsletterSections.findIndex(x => x.section_id === section.section_id);
    if (this.moveIndex !== 0) {
      // initialises the section and the pos that is moving up
      this.moveSection = this.newsletterSections[this.moveIndex];
      this.movePos = this.newsletterSections[this.moveIndex - 1].section_pos;
      // add the section moving down to its new position
      this.newsletterSections[this.moveIndex] = this.newsletterSections[this.moveIndex - 1];
      this.newsletterSections[this.moveIndex].section_pos = this.moveSection.section_pos;
      // add the section moving up to its new position
      this.newsletterSections[this.moveIndex - 1] = this.moveSection;
      // apply the new position to the section being moved
      this.newsletterSections[this.moveIndex - 1].section_pos = this.movePos;
      // save section changes
      this.newsletterService.saveSection(this.newsletterSections[this.moveIndex - 1]).subscribe((res: NewsletterSectionResponseModel) => {
        if (res && res.status) {
          this.commonService.implementToast("Successfully move section up", "Success");
        }
      }),
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        }
    }
  }

  moveDown(section: NewsletterSection): void {
    // gets the index of the section moving down
    this.moveIndex = this.newsletterSections.findIndex(x => x.section_id === section.section_id);
    if (this.moveIndex !== this.newsletterSections.length - 1) {
      // initialises the section and the pos that is moving down
      this.moveSection = this.newsletterSections[this.moveIndex];
      this.movePos = this.newsletterSections[this.moveIndex + 1].section_pos;
      // overwrite section moving down with the section moving up
      this.newsletterSections[this.moveIndex] = this.newsletterSections[this.moveIndex + 1];
      this.newsletterSections[this.moveIndex].section_pos = this.moveSection.section_pos;
      // overwrite setion moving up with the section moving down
      this.newsletterSections[this.moveIndex + 1] = this.moveSection;
        this.newsletterSections[this.moveIndex + 1].section_pos = this.movePos;
      // save section changes
      this.newsletterService.saveSection(this.newsletterSections[this.moveIndex]).subscribe((res: NewsletterSectionResponseModel) => {
        if (res && res.status) {
          this.commonService.implementToast("Successfully move section down", "Success");
        }
      }),
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        }
    }
  }

  addBlock(parentId: string, type: string): void {
    this.newletterToEditId = parentId;
    this.ngProgress.start();
    switch (type) {
      case 'products':
        this.addingTitle = "Adding new product list...";
        
        this.newsletterService.addBlock(parentId, type, this.sendNewIdToSection).subscribe((res: NewsletterSectionResponseModel) => {
          this.refreshNewsletterInfo.next(res);
          this.ngProgress.done();
        },
          (error: any) => {
            console.error(error);
            this.ngProgress.done();
          });
        break;
      case 'link':
        this.addingTitle = "Adding new link...";
        this.newsletterService.addLink(parentId, this.sendNewIdToSection).subscribe((res: NewsletterSectionResponseModel) => {
          this.refreshNewsletterInfo.next(res);
          this.ngProgress.done();
        },
          (error: any) => {
            console.error(error);
            this.ngProgress.done();
          });
        break;
      case 'nl_comment':
        this.addingTitle = "Adding new comment...";
        this.newsletterService.addBlock(parentId, type, this.sendNewIdToSection).subscribe((res: NewsletterSectionResponseModel) => {
          this.refreshNewsletterInfo.next(res);
          this.ngProgress.done();
        },
          (error: any) => {
            console.error(error);
            this.ngProgress.done();
          });
        break;
      case 'nl_heading':
        this.addingTitle = "Adding new heading...";
        this.newsletterService.addBlock(parentId, type, this.sendNewIdToSection).subscribe((res: NewsletterSectionResponseModel) => {
          this.refreshNewsletterInfo.next(res);
          this.ngProgress.done();
        },
          (error: any) => {
            console.error(error);
            this.ngProgress.done();
          });
        break;
    }
  }

  loadingTitleEvent(emitData: {newsId:string,title:string} | null) {
    if(emitData != null) {
      this.newletterToEditId = emitData.newsId;
      this.addingTitle = emitData.title;
    } else {
      this.addingTitle = "";
      this.newletterToEditId = "";
    }
  }

  receiveEditBlockEvent($event): void {
    this.editSectionEvent.emit($event);
  }

  cancelSaveSectionContent(): void {
    this.editSectionContent = false;
    this.editSectionEvent.emit(this.editSectionContent);
    $('#cmsEditableSectionContent').css('display', 'none');
  }

  ngOnDestroy() {
    if (this.catalogueWatchSubscription) {
      this.catalogueWatchSubscription.unsubscribe();
    }
    if (this.catalogueSubscription) {
      this.catalogueSubscription.unsubscribe();
    }
    if (this.colorSubscription) {
      this.colorSubscription.unsubscribe();
    }
  }
}
